export const profile = {
  name: "Ashwin Kalra",
  first: "Ashwin",
  last: "Kalra",
  role: "Marketing & Strategy",
  tagline: "Corporate strategist with a marketer's instinct — turning data, brand and behavior into growth.",
  location: "Mumbai, IN",
  email: "ashwinkalra2000@gmail.com",
  phone: "+91 9997774802",
  linkedin: "https://linkedin.com/in/ashwinkalra/",
};

export const about = [
  "I'm a corporate strategy and brand management professional working at the intersection of pharma, adtech and consumer goods.",
  "I build the connective tissue between plans on paper and moves in the market — automating field intelligence, launching portfolios, and running programmatic budgets that actually convert.",
  "My playbook: sharp market intelligence, scientific and creative storytelling, and the discipline to make it stick across 26 regions and thousands of field reps.",
];

export const experiences = [
  {
    company: "Alkem Laboratories Ltd.",
    role: "Deputy Manager — Corporate Strategy & Business Development",
    dates: "Jun 2025 — Present",
    location: "Mumbai",
    bullets: [
      "Built an automated 'Field Nudges' framework for 12,000+ field employees delivering real-time behavioral triggers.",
      "Unified 5+ data lakes (SAP, IQVIA, SMSRC, HR, Finance) into a Power BI + AI reporting layer — 33% faster monthly MIS.",
      "Automated field targeting from DSM → MR in 30 minutes across all 26 divisions; saved ~2 months for marketing & finance.",
      "Scaled MediSamvad HCP platform to 1.7L+ doctors for scientific promotion.",
      "Managed INR 6.7 Cr programmatic ad budget across 50+ brand lines and 26 regions.",
    ],
  },
  {
    company: "Doceree Media Pvt. Ltd.",
    role: "Brand Manager",
    dates: "Apr 2025 — May 2025",
    location: "Global (US / UK / EU)",
    bullets: [
      "Supported digital brand strategies for regulated marketing automation across US, UK and EU markets.",
      "Directed full-cycle GTM for new digital product portfolios — 95% on-time delivery in 60-day cycles.",
      "Established a brand governance framework with 100% adherence across marketing touchpoints.",
    ],
  },
  {
    company: "Bira 91 Beverages Ltd.",
    role: "Management Trainee",
    dates: "May 2024 — Feb 2025",
    location: "Delhi NCR · Chandigarh · Mysuru · Bengaluru",
    bullets: [
      "Analyzed 10 years of beer sales data to identify state-specific product strategies. Cicerone L1 certified.",
      "Redesigned B9 Taproom + launched a mood-based 'Beer Finder' → +35% footfall in Chandigarh.",
      "Optimized brewery ops in Mysuru and restructured IDTs & warehouse layouts in Bengaluru to cut logistics costs.",
      "Managed 400+ HoReCa key accounts in Delhi NCR; awarded 'Top Sales Performer' for new account acquisition.",
    ],
  },
  {
    company: "Tata Consumer Products Ltd.",
    role: "Emerging Leaders Plus Summer Intern",
    dates: "Apr 2023 — Jun 2023",
    location: "3 states · 11 regions",
    bullets: [
      "Led GTM for 4 product launches across 450+ retail outlets → +28.5% regional sales volume.",
      "Built a structured SOP framework for product launches that improved operational efficiency.",
    ],
  },
  {
    company: "S-CCI India Pvt. Ltd.",
    role: "Digital Marketing Intern",
    dates: "Jun 2023 — Jul 2023",
    location: "India",
    bullets: [
      "Automobile aftermarket research feeding into service strategy.",
      "Revamped digital UI and social media presence, amplifying brand visibility.",
    ],
  },
];

export const skills = {
  "Core Strategy": [
    "Brand Strategy", "Brand Governance", "GTM Planning", "Campaign Execution (ATL/BTL/TTL)",
    "In-Market Visibility", "Trade Activations", "Packaging Strategy", "Account Management",
    "Agency Collaboration", "Creative Briefing",
  ],
  "Digital & Analytics": [
    "AI/ML Projects", "Programmatic Advertising", "Marketing Automation", "SEO",
    "Competitive Intelligence", "MIS Reporting", "Secondary Sales Monitoring",
    "Process Engineering", "Primary Surveys",
  ],
  "Frameworks": [
    "Medical Messaging", "Scientific Promotion", "Cross-Functional Coordination",
    "Sales Force Effectiveness", "Competitor Benchmarking",
  ],
};

export const education = [
  {
    degree: "MBA — Sales & Marketing",
    school: "SCMHRD · Symbiosis University, Pune",
    years: "Jun 2022 – Jun 2024",
    grade: "7.7 / 10",
    activities: [
      "Sports — 1st position, Intra-College Badminton Championship; Member, College Badminton Team",
      "Corporate Competitions — WIPRO B-PRO 3.0 (Semi-Finalist), JSW Challenge (Semi-Finalist), GSK E-Cube 2023 (Semi-Finalist), MI-Summit 5.0 (Campus Winner, Xiaomi India), Interrobang S13 (2nd Runner Up, ITC)",
    ],
  },
  {
    degree: "BMS — International Marketing",
    school: "Ram Lal Anand College · Delhi University",
    years: "2018 – 2021",
    grade: "8.1 / 10",
    activities: [
      "President (2020–21) & Vice President (2019–20), The Management Society",
      "Coordinator, The Placement Cell",
      "Documentation Head, The Literary Society",
      "Executive Board Member, The Debate Team",
      "Member, The Anchoring Society",
    ],
  },
  {
    degree: "High School — Commerce",
    school: "Springdales School, Dhaula Kuan",
    years: "2004 – 2018",
    grade: "10 / 10 (Class X) · 86.6% (Class XII)",
    activities: [
      "Straight 9-year academic prize winner; part of 5+ school clubs",
      "Active in quizzes, debates and inter-school competitions",
    ],
  },
];

export const certifications = [
  "Oxford AI Program — Saïd Business School (2025)",
  "NVIDIA — AI for All: Basics to GenAI (2025)",
  "Microsoft — Generative AI Foundations (2025)",
  "Columbia+ — Prompt Engineering with OpenAI (2025)",
  "Bloomberg Market Concepts · CFA Investment Foundation (99th percentile)",
];

export const wins = [
  "LPC Pharma AI Innovation Award — Alkem Labs",
  "DigiPharmaX Award — Innovation in Therapy Awareness",
  "Hall of Fame — Alkem Labs (top of 5,000+ HO employees)",
  "Beast Award — Top Sales Performer, Bira 91",
  "2nd Runner Up — Interrobang S13, ITC Limited (vs. 22,500+ contestants)",
  "Campus Winner — MI-Summit 5.0, Xiaomi India",
  "National Semi-Finalist — GSK E-Cube 2023 (top 30 of 11,000 teams)",
  "National Semi-Finalist — JSW Challenge 2023, JSW Group",
  "National Semi-Finalist — Wipro B-PRO 3.0, Wipro Limited",
  "National Finalist — STRAT-E-GIA 2023, SCMHRD (top of 1,110 teams)",
  "National Finalist — Godrej LOUD 2022, Godrej Consumer Products",
  "Top 10% — 4th National Quiz on IBC, Insolvency & Bankruptcy Board of India",
  "Bronze Medalist — Delhi Olympic Games 2021 (Taekwondo)",
  "Winner — The Trading Arena, NMIMS Indore",
  "Winner — The Business Quiz, EDC BVPCOE",
  "Winner — The Merchants of Trade, Bharti Vidyapeeth",
  "Runners Up — GNOSIS 2020, XLRI Jamshedpur",
  "2nd Runners Up — Socio-Business Case Study, BITS Pilani",
];

export const volunteering = [
  {
    role: "Volunteer",
    org: "Alkem Foundation · S.M.I.L.E.",
    dates: "Jun 2025 — Present",
    detail: "Blood donation drives, school wall painting, and seedball plantation.",
  },
  {
    role: "Fundraising Volunteer",
    org: "Confederation of Empowerment Initiatives (CEI)",
    dates: "Dec 2022 — Feb 2023",
    detail: "Poverty alleviation fundraiser for BPL tribal and rural families.",
  },
  {
    role: "Senior Member",
    org: "Women Welfare Advisory Committee (WWAC)",
    dates: "Sep 2019 — Jan 2021",
    detail: "Promoted gender equality and a safer environment for women on campus.",
  },
  {
    role: "Awareness Volunteer",
    org: "Indian Red Cross Society (IRCS), New Delhi",
    dates: "May 2017 — Jun 2017",
    detail: "Spread thalassemia awareness and encouraged blood donation.",
  },
  {
    role: "Teacher's Aide",
    org: "Springdales School",
    dates: "May 2017 — May 2018",
    detail: "Provided remedial classes to students with special needs.",
  },
];

export const suggestions = [
  "What are you working on at Alkem?",
  "Walk me through your biggest brand win.",
  "How do you use AI in marketing?",
  "Why marketing & strategy?",
];
